// extracted by mini-css-extract-plugin
export default {"heading":"_34erxowrF1HrZCnVVosadm","frameResizer":"_2dHCnWZwlFPxNWRIQYBHOn","frame":"_3ZQiascQZomlOiAEe99j3W"};